import React, { useState, useEffect, useRef } from 'react'
import "./../styles/crossword.css";
import "./../styles/crossword2.css";
import { Link } from 'react-router-dom'
import GameNav from '../GameNav';


export default function CrossWord() {

    const [activeQuestion, setActiveQuestion] = useState(1);
    const [activeStreak, setActiveStreak] = useState([]);
    const [inputValues, setInputValues] = useState([]);
    const [checkAnswersClicked, setCheckAnswersClicked] = useState(false);
    // const rows = 18;
    const rows = 18;
    const cols = 17;
    // const rows = 25;
    // const cols = 14;
    const initialPuzzleState = Array.from({ length: rows }, () => Array.from({ length: cols }, () => null));
    const [puzzle, setPuzzle] = useState(initialPuzzleState);
    const [win, setWin] = useState(false);

    const correctAnswers = [
        'F', 'O', 'U', 'R', 'D', 'I', 'E', 'C', 'T', 'O', 'R', 'H', 'O', 'R', 'E', 'O', 'G', 'R', 'A', 'P', 'H', 'E', 'R', 'D', 'I', 'S', 'C', 'O', 'R', 'I', 'S', 'R', 'M', 'O', 'D', 'U', 'L', 'A', 'T', 'I', 'O', 'N', 'A', 'D', 'J', 'U', 'D', 'I', 'C', 'A', 'T', 'O', 'S', 'G', 'E', 'E', 'T', 'E', 'N', 'O', 'R', 'A', 'R', 'R', 'A', 'N', 'G', 'M', 'N', 'W', 'N', 'T', 'E'
    ]




    const resetGame = () => {
        setActiveQuestion(1);
        setPuzzle(initialPuzzleState);
        setInputValues([]);
        setEnteredValues(Array(filledCells.length).fill(null)); // Reset enteredValues
        setCheckAnswersClicked(false);
        setWin(false);  // Reset win state
    };

    const filledCells = [
        [0, 8],
        [1, 8],
        [2, 8],
        [3, 8],

        [3, 6],
        [3, 7],
        [3, 9],
        [3, 10],
        [3, 11],
        [3, 12],
        [3, 13],


        [4, 10],
        [5, 10],
        [6, 10],
        [7, 10],
        [8, 10],
        [9, 10],
        [10, 10],
        [11, 10],
        [12, 10],
        [13, 10],
        [14, 10],
        [15, 10],

        [5, 12],
        [6, 12],
        [7, 12],
        [8, 12],
        [9, 12],

        [7, 7],
        [7, 8],
        [7, 9],
        [7, 11],


        [8, 14],
        [9, 14],
        [10, 14],
        [11, 14],
        [12, 14],
        [13, 14],
        [14, 14],
        [15, 14],
        [16, 14],
        [17, 14],


        [10, 0],
        [10, 1],
        [10, 2],
        [10, 3],
        [10, 4],
        [10, 5],
        [10, 6],
        [10, 7],
        [10, 8],
        [10, 9],
        [10, 11],


        [12, 13],
        [12, 15],
        [12, 16],

        [13, 12],
        [14, 12],
        [15, 12],
        [16, 12],
        [17, 12],

        [14, 4],
        [14, 5],
        [14, 6],
        [14, 7],
        [14, 8],
        [14, 9],
        [14, 11],
        [14, 13],


        [9, 5],
        [11, 5],
        [12, 5],
        [13, 5],










    ];


    const [enteredValues, setEnteredValues] = useState(Array(filledCells.length).fill(null));

    useEffect(() => {
        if (activeQuestion === 1) {
            setActiveStreak([
                [0, 8],
                [1, 8],
                [2, 8],
                [3, 8]
            ]);

            setInputValues([
                [''],
                [''],
                [''],
                ['']

            ])
        } else if (activeQuestion === 2) {
            setActiveStreak([
                [3, 6],
                [3, 7],
                [3, 8],
                [3, 9],
                [3, 10],
                [3, 11],
                [3, 12],
                [3, 13],
            ]);

            setInputValues([
                [''],
                [''],
                [''],
                [''],
                [''],
                [''],
                [''],
                [''],

            ])

        } else if (activeQuestion === 3) {
            setActiveStreak([

                [3, 10],
                [4, 10],
                [5, 10],
                [6, 10],
                [7, 10],
                [8, 10],
                [9, 10],
                [10, 10],
                [11, 10],
                [12, 10],
                [13, 10],
                [14, 10],
                [15, 10],

            ]);

            setInputValues([
                [''],
                [''],
                [''],
                [''],
                [''],
                [''],
                [''],
                [''],
                [''],
                [''],
                [''],
                [''],
                ['']
            ])
        } else if (activeQuestion === 4) {
            setActiveStreak([

                [5, 12],
                [6, 12],
                [7, 12],
                [8, 12],
                [9, 12],
            ])

            setInputValues([
                [''],
                [''],
                [''],
                [''],
                ['']

            ])

        } else if (activeQuestion === 5) {
            setActiveStreak([

                [7, 7],
                [7, 8],
                [7, 9],
                [7, 10],
                [7, 11],
                [7, 12]


            ])

            setInputValues([
                [''],
                [''],
                [''],
                [''],
                [''],
                ['']

            ])
        } else if (activeQuestion === 6) {
            setActiveStreak([
                [8, 14],
                [9, 14],
                [10, 14],
                [11, 14],
                [12, 14],
                [13, 14],
                [14, 14],
                [15, 14],
                [16, 14],
                [17, 14],
            ])

            setInputValues([
                [''],
                [''],
                [''],
                [''],
                [''],
                [''],
                [''],
                [''],
                ['']


            ])
        } else if (activeQuestion === 7) {
            setActiveStreak([
                [10, 0],
                [10, 1],
                [10, 2],
                [10, 3],
                [10, 4],
                [10, 5],
                [10, 6],
                [10, 7],
                [10, 8],
                [10, 9],
                [10, 10],
                [10, 11],
            ])

            setInputValues([
                [''],
                [''],
                [''],
                [''],
                [''],
                [''],
                [''],
                [''],
                [''],
                [''],
                [''],
                ['']

            ])
        } else if (activeQuestion === 8) {
            setActiveStreak([
                [12, 13],
                [12, 14],
                [12, 15],
                [12, 16],
            ])

            setInputValues([
                [''],
                [''],
                [''],
                ['']

            ])
        } else if (activeQuestion === 9) {
            setActiveStreak([
                [13, 12],
                [14, 12],
                [15, 12],
                [16, 12],
                [17, 12],

            ])

            setInputValues([
                [''],
                [''],
                [''],
                [''],
                ['']

            ])
        } else if (activeQuestion === 10) {
            setActiveStreak([

                [14, 4],
                [14, 5],
                [14, 6],
                [14, 7],
                [14, 8],
                [14, 9],
                [14, 10],
                [14, 11],
                [14, 12],
                [14, 13],
                [14, 14],

            ])

            setInputValues([
                [''],
                [''],
                [''],
                [''],
                [''],
                [''],
                [''],
                [''],
                [''],
                [''],
                ['']
            ])
        } else if (activeQuestion === 11) {
            setActiveStreak([

                [9, 5],
                [10, 5],
                [11, 5],
                [12, 5],
                [13, 5],
                [14, 5]

            ])

            setInputValues([
                [''],
                [''],
                [''],
                [''],
                [''],
                ['']

            ])
        }



    }, [activeQuestion]);



    const totalQuestions = 11;

    const handleChange = (index, e) => {
        const newInputValues = [...inputValues];
        newInputValues[index] = e.target.value.toUpperCase();
        setInputValues(newInputValues);
    };


    const handleKeyDown = (index, e) => {
        if (/^[a-zA-Z]$/.test(e.key)) {
            e.preventDefault();
            const newInputValues = [...inputValues];
            newInputValues[index] = e.key.toUpperCase();
            setInputValues(newInputValues);

            if (index < activeStreak.length - 1) {
                const nextIndex = index + 1;
                document.getElementById(`input-${nextIndex}`).focus();
            }
        } else if (e.key === 'Backspace') {
            e.preventDefault();
            const currentInput = inputValues[index];

            if (currentInput === '') {
                if (index > 0) {
                    const prevIndex = index - 1;
                    document.getElementById(`input-${prevIndex}`).focus();
                }
            } else {
                const newInputValues = [...inputValues];
                newInputValues[index] = '';
                setInputValues(newInputValues);
            }
        }
    };

    const resetInputValues = () => {
        setInputValues(Array(activeStreak.length).fill(''));
    };


    // const checkCompletion = () => {
    //     const isPuzzleComplete = enteredValues.every(value => value !== null);
    //     if (isPuzzleComplete) {
    //         console.log('Puzzle is complete!');
    //         filledCells.forEach(([row, col], index) => {
    //             console.log(`Value at (${row}, ${col}): ${enteredValues[index]}`);
    //         });
    //     }
    // };
    const answerSubmit = () => {
        if (inputValues.every(value => typeof value === 'string' && value.trim() !== '' && value !== null)) {
            const newEnteredValues = [...enteredValues];
            const newPuzzle = puzzle.map(row => [...row]);
            activeStreak.forEach(([row, col], index) => {
                const cellIndex = filledCells.findIndex(([r, c]) => r === row && c === col);
                if (cellIndex !== -1) {
                    newEnteredValues[cellIndex] = inputValues[index];
                    newPuzzle[row] = [...newPuzzle[row]];
                    newPuzzle[row][col] = inputValues[index];
                }
            });
            setEnteredValues(newEnteredValues);
            setPuzzle(newPuzzle);
            nextQuestion();
        } else {
            alert('Please fill in the entire answer before submitting');
        }
    };



    const checkAnswers = (e) => {
        e.preventDefault();
        const isCorrect = enteredValues.every((value, index) => value.toUpperCase() === correctAnswers[index]);
        setCheckAnswersClicked(true);
        if (isCorrect) {
            setWin(true);
        }
    };




    const nextQuestion = () => {
        const newQuestion = (activeQuestion % totalQuestions) + 1;
        setActiveQuestion(newQuestion);
        resetInputValues();
    };

    const prevQuestion = () => {
        const newQuestion = (activeQuestion - 2 + totalQuestions) % totalQuestions + 1;
        setActiveQuestion(newQuestion);
    };



    const grid = Array.from({ length: rows }, () => Array.from({ length: cols }).fill(0));

    filledCells.forEach(([row, col]) => {
        if (row < rows && col < cols) {
            grid[row][col] = 1;
        }
    });



    const gridItems = [];

    const clues = [
        { number: 1, start: [0, 8] },
        { number: 2, start: [3, 6], },
        { number: 3, start: [3, 10], },
        { number: 4, start: [5, 12] },
        { number: 5, start: [7, 7] },
        { number: 6, start: [8, 14] },
        { number: 7, start: [10, 0] },
        { number: 8, start: [12, 13] },
        { number: 9, start: [13, 12] },
        { number: 10, start: [14, 4] },
        { number: 11, start: [9, 5] },


    ];


    const streakClick = (row, col) => {
        const activeQuestionIndex = clues.findIndex(clue => clue.start[0] === row && clue.start[1] === col);


        if (activeQuestionIndex !== -1) {
            const questionStreakNumber = clues[activeQuestionIndex].number;
            setActiveQuestion(questionStreakNumber);
        }

    }




    for (let row = 0; row < rows; row++) {
        for (let col = 0; col < cols; col++) {
            // const [row, col] = filledCells[index];
            const isFilled = grid[row] && grid[row][col] === 1;

            const isStartOfClue = clues && activeStreak && clues.some(
                (clue) => clue && clue.start && Array.isArray(clue.start) && clue.start[0] === row && clue.start[1] === col
            );

            const cellStyle = {
                border: isFilled ? '1px solid #826A8C' : 'none',
                backgroundColor: isFilled ? '#fff' : 'transparent',
                boxSizing: 'border-box',
                position: 'relative'

            };

            const cellContent = (
                <div

                >
                    <span

                        className={`entered-letter ${checkAnswersClicked &&
                            enteredValues.find(
                                (value, index) =>
                                    filledCells[index][0] === row && filledCells[index][1] === col
                            ) === correctAnswers[
                            filledCells.findIndex(
                                (cell) => cell[0] === row && cell[1] === col
                            )
                            ]
                            ? 'correct'
                            : checkAnswersClicked &&
                                enteredValues.find(
                                    (value, index) =>
                                        filledCells[index][0] === row && filledCells[index][1] === col
                                ) !== correctAnswers[
                                filledCells.findIndex(
                                    (cell) => cell[0] === row && cell[1] === col
                                )
                                ]
                                ? 'incorrect'
                                : 'mid-game-letter'

                            }`}
                    >
                        {enteredValues.find((value, index) => filledCells[index][0] === row && filledCells[index][1] === col) || ''}
                    </span>
                    {isStartOfClue && (
                        <div className='clue'>
                            {clues.find(clue => clue && clue.start && clue.start[0] === row && clue.start[1] === col)?.number}
                        </div>
                    )}
                </div>
            );
            // win !== true &&
            gridItems.push(
                <div className={`cell ${activeStreak.length > 0 && activeStreak.some(([r, c]) => r === row && c === col) ? 'active-streak-cell' : ''}`} key={`${row}-${col}`} style={cellStyle}
                    onClick={() => streakClick(row, col)}
                >
                    {cellContent}
                </div>
            );
        }
    }


    return (
        <div className='crossword-main'>
            <GameNav />
            <div className='crossword-container'>


                <div className='crossword-bg'>

                    <img className='cwimg1' src='images/crossword/1-min.png' />

                    <img className='cwimg2' src='images/crossword/2-min.png' />

                    <img className='cwimg3' src='images/crossword/3-min.png' />


                    <div id='crossword-grid'>
                        {gridItems}
                    </div>

                </div>

            </div>

            {win ? (
                <div className='crossword-win-screen'>


                    <h2>You Win!</h2>

                    <Link to='/crossword2'>
                        <button className='nextLevelCWbtn'>Next Level</button>
                    </Link>


                </div>
            ) : (
                <></>
            )}


            <div className='crossword-control-main' style={{ position: 'relative' }}>
                <img className='cross-ctrl-img' src='images/crossword/4-min.png' />

                <div className={`cw-outer ${win ? 'win-blur' : ''}`} style={{ width: '100%', zIndex: '100' }}>
                    <div className='crossword-control'>

                        <div onClick={prevQuestion} className=' prev-btn questions-btn btn-background-circle-q'>
                            <svg className='arrow-prev-q arrow-q' xmlns="http://www.w3.org/2000/svg" viewBox="0 0 114.53 162.9">
                                <path
                                    className='prev svg-btn-q'
                                    d="M217.4,165.87a7.76,7.76,0,0,0,0,12.12l52,41.61,38.68,30.94a12.87,12.87,0,0,0,20.91-10h0a12.88,12.88,0,0,0-4.83-10.05L310.62,219.6,251,171.93l59.6-47.65,13.57-10.85A12.89,12.89,0,0,0,329,103.38h0a12.87,12.87,0,0,0-20.91-10l-38.68,31Z"
                                    transform="translate(-214.49 -90.49)"
                                />
                            </svg>
                        </div>
                        <div className={`question ${activeQuestion === 1 ? 'active-question' : ''}`}>
                            <div className='question-labl'>
                                <h4>Question 1</h4>
                                <img src={process.env.PUBLIC_URL + '/images/down-icon.png'} height='28px'></img>
                            </div>

                            <p>How many vocal parts traditionally in show choir music?</p>
                        </div>
                        <div className={`question ${activeQuestion === 2 ? 'active-question' : ''}`}>
                            <div className='question-labl'>
                                <h4>Question 2</h4>
                                <img src={process.env.PUBLIC_URL + '/images/across-icon.png'} width='30px'></img>
                            </div>
                            <p>Title of the show choir teacher?</p>
                        </div>
                        <div className={`question ${activeQuestion === 3 ? 'active-question' : ''}`}>
                            <div className='question-labl'>
                                <h4>Question 3</h4>
                                <img src={process.env.PUBLIC_URL + '/images/down-icon.png'} height='28px'></img>
                            </div>
                            <p>Title of the person who designs the dance moves of the show choir performance?</p>
                        </div>
                        <div className={`question ${activeQuestion === 4 ? 'active-question' : ''}`}>
                            <div className='question-labl'>
                                <h4>Question 4</h4>
                                <img src={process.env.PUBLIC_URL + '/images/down-icon.png'} height='28px'></img>
                            </div>
                            <p>Dance term describing the dance style of the 1970’s?</p>
                        </div>
                        <div className={`question ${activeQuestion === 5 ? 'active-question' : ''}`}>
                            <div className='question-labl'>
                                <h4>Question 5</h4>
                                <img src={process.env.PUBLIC_URL + '/images/across-icon.png'} width='30px'></img>
                            </div>
                            <p>Show Choir Performs on what?</p>
                        </div>
                        <div className={`question ${activeQuestion === 6 ? 'active-question' : ''}`}>
                            <div className='question-labl'>
                                <h4>Question 6</h4>
                                <img src={process.env.PUBLIC_URL + '/images/down-icon.png'} height='28px'></img>
                            </div>
                            <p>Term used when song moves musically from one key to another key?</p>
                        </div>
                        <div className={`question ${activeQuestion === 7 ? 'active-question' : ''}`}>
                            <div className='question-labl'>
                                <h4>Question 7</h4>
                                <img src={process.env.PUBLIC_URL + '/images/across-icon.png'} width='30px'></img>
                            </div>
                            <p>Formal name for the show choir competition judges:</p>
                        </div>
                        <div className={`question ${activeQuestion === 8 ? 'active-question' : ''}`}>
                            <div className='question-labl'>
                                <h4>Question 8</h4>
                                <img src={process.env.PUBLIC_URL + '/images/across-icon.png'} width='30px'></img>
                            </div>
                            <p>TV show about show choir?</p>
                        </div>
                        <div className={`question ${activeQuestion === 9 ? 'active-question' : ''}`}>
                            <div className='question-labl'>
                                <h4>Question 9</h4>
                                <img src={process.env.PUBLIC_URL + '/images/down-icon.png'} height='28px'></img>
                            </div>
                            <p>The highest male vocal part?</p>
                        </div>
                        <div className={`question ${activeQuestion === 10 ? 'active-question' : ''}`}>
                            <div className='question-labl'>
                                <h4>Question 10</h4>
                                <img src={process.env.PUBLIC_URL + '/images/across-icon.png'} width='30px'></img>
                            </div>
                            <p>Term used for song rewritten for show choir use?</p>
                        </div>

                        <div className={`question ${activeQuestion === 11 ? 'active-question' : ''}`}>
                            <div className='question-labl'>
                                <h4>Question 11</h4>
                                <img src={process.env.PUBLIC_URL + '/images/down-icon.png'} height='28px'></img>
                            </div>
                            <p>What season of the year do show choir competitions begin?</p>
                        </div>


                        <div onClick={nextQuestion} className=' next-btn questions-btn btn-background-circle-q'>
                            <svg className='arrow-next-q arrow-q' xmlns="http://www.w3.org/2000/svg" viewBox="0 0 114.53 162.9">
                                <path
                                    className='next svg-btn-q'
                                    d="M326.1,165.87a7.75,7.75,0,0,1,0,12.12l-52,41.61-38.69,30.94a12.86,12.86,0,0,1-20.9-10h0a12.88,12.88,0,0,1,4.83-10.05l13.57-10.85,59.6-47.67-59.6-47.65-13.57-10.85a12.89,12.89,0,0,1-4.83-10.05h0a12.86,12.86,0,0,1,20.9-10l38.69,31Z"
                                    transform="translate(-214.49 -90.49)"
                                />
                            </svg>
                        </div>
                    </div>
                    <form className='question-input'>
                        <div className='input-cells'>
                            {activeStreak.map((cell, index) => (
                                <input
                                    key={index}
                                    id={`input-${index}`}
                                    className='question-input-cell'
                                    value={inputValues[index]}
                                    onChange={(e) => handleChange(index, e)}
                                    onKeyDown={(e) => handleKeyDown(index, e)}

                                    maxLength={1}
                                />
                            ))}
                        </div>


                        <div className='input-btns'>
                            {inputValues.every(value => typeof value === 'string' && value.trim() !== '' && value !== null) ? (
                                <div className='submit-btn' onClick={answerSubmit}>
                                    Submit
                                </div>
                            ) : (
                                <div className='submit-btn-disabled' onClick={answerSubmit}>
                                    Submit
                                </div>
                            )}



                            <div>
                                {enteredValues.every(value => value !== null || '') ? (
                                    <button className='check-btn' onClick={checkAnswers}>Check</button>
                                ) : (
                                    <button type="button" className='disabled-check-btn'>Check</button>
                                )
                                }

                            </div>
                        </div>
                    </form>


                </div>

            </div>




        </div>
    )
}


